/**
 * Cart Line Limit — 60 productos distintos máximo
 * Para: OleoFlex Importaciones (Enterprise 1.6.2)
 *
 * Intercepta TODOS los intentos de agregar al carrito (tema, apps, etc.)
 * mediante monkey-patch de fetch(). Si el carrito ya tiene 60 líneas
 * de producto distintas, bloquea la acción y muestra un popup.
 *
 * Límite configurable vía window.__cartLineLimit (default 60).
 */
(function () {
  'use strict';

  var MAX_LINES = window.__cartLineLimit || 60;
  var POPUP_MESSAGE = window.__cartLineLimitMsg || 'Has llegado al m\u00e1ximo de productos por compra. (60 items)';

  // =========================================================================
  // Popup modal
  // =========================================================================
  function createPopupStyles() {
    if (document.getElementById('cart-limit-popup-styles')) return;

    var style = document.createElement('style');
    style.id = 'cart-limit-popup-styles';
    style.textContent = [
      '.cart-limit-overlay {',
      '  position: fixed; top: 0; left: 0; width: 100%; height: 100%;',
      '  background: rgba(0,0,0,0.45); z-index: 999999;',
      '  display: flex; align-items: center; justify-content: center;',
      '  opacity: 0; transition: opacity 0.3s ease;',
      '}',
      '.cart-limit-overlay.is-visible { opacity: 1; }',
      '.cart-limit-popup {',
      '  background: #fff; border-radius: 12px; padding: 36px 32px 28px;',
      '  max-width: 420px; width: 90%; text-align: center;',
      '  box-shadow: 0 12px 40px rgba(0,0,0,0.15);',
      '  transform: translateY(20px); transition: transform 0.3s ease;',
      '  font-family: "DM Sans", sans-serif;',
      '}',
      '.cart-limit-overlay.is-visible .cart-limit-popup { transform: translateY(0); }',
      '.cart-limit-popup__icon {',
      '  width: 56px; height: 56px; margin: 0 auto 20px;',
      '  background: #FFF3CD; border-radius: 50%;',
      '  display: flex; align-items: center; justify-content: center;',
      '}',
      '.cart-limit-popup__icon svg { width: 28px; height: 28px; color: #856404; }',
      '.cart-limit-popup__title {',
      '  font-size: 20px; font-weight: 700; color: #000; margin: 0 0 10px;',
      '  font-family: "DM Sans", sans-serif; letter-spacing: -0.01em;',
      '}',
      '.cart-limit-popup__msg {',
      '  font-size: 15px; color: #525352; margin: 0 0 28px; line-height: 1.6;',
      '  font-family: "DM Sans", sans-serif;',
      '}',
      '.cart-limit-popup__btn {',
      '  display: inline-block; padding: 12px 26px; background: #525352; color: #fff;',
      '  border: none; border-radius: 28px; font-size: 15px; cursor: pointer;',
      '  font-weight: 500; font-family: "DM Sans", sans-serif;',
      '  transition: background 0.2s; letter-spacing: 0.02em;',
      '}',
      '.cart-limit-popup__btn:hover { background: #3a3b3a; }'
    ].join('\n');

    document.head.appendChild(style);
  }

  function showPopup() {
    createPopupStyles();

    // Evitar popups duplicados
    var existing = document.querySelector('.cart-limit-overlay');
    if (existing) return;

    var overlay = document.createElement('div');
    overlay.className = 'cart-limit-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'L\u00edmite de carrito alcanzado');

    overlay.innerHTML = [
      '<div class="cart-limit-popup">',
      '  <div class="cart-limit-popup__icon">',
      '    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">',
      '      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />',
      '    </svg>',
      '  </div>',
      '  <p class="cart-limit-popup__title">L\u00edmite alcanzado</p>',
      '  <p class="cart-limit-popup__msg">' + POPUP_MESSAGE + '</p>',
      '  <button class="cart-limit-popup__btn" type="button">Entendido</button>',
      '</div>'
    ].join('');

    function closePopup() {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 300);
    }

    overlay.querySelector('.cart-limit-popup__btn').addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    function onEsc(e) {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', onEsc);
      }
    }
    document.addEventListener('keydown', onEsc);

    document.body.appendChild(overlay);
    overlay.offsetHeight; // forzar reflow
    overlay.classList.add('is-visible');
  }

  // =========================================================================
  // Restaurar botón "Añadir al carrito" del tema Enterprise
  // =========================================================================
  function restoreSubmitButtons() {
    var btns = document.querySelectorAll('[name="add"].is-loading');
    btns.forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.classList.remove('is-success');
      btn.removeAttribute('aria-disabled');
    });
  }

  // =========================================================================
  // Interceptar fetch — monkey-patch
  // =========================================================================
  var originalFetch = window.fetch;

  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    var opts = args[1] || {};
    var method = (opts.method || 'GET').toUpperCase();

    // Solo interceptar POST a /cart/add
    var isCartAdd = method === 'POST' && /\/cart\/add/i.test(url);

    if (!isCartAdd) {
      return originalFetch.apply(this, args);
    }

    // Consultar carrito actual antes de permitir el add
    return originalFetch.call(this, '/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
    .then(function (cartResponse) {
      return cartResponse.json();
    })
    .then(function (cartData) {
      var currentLines = cartData.items ? cartData.items.length : 0;

      // Determinar cuántas líneas NUEVAS se agregarían
      var existingVariantIds = {};
      if (cartData.items) {
        cartData.items.forEach(function (item) {
          existingVariantIds[String(item.variant_id)] = true;
        });
      }

      var newVariantId = null;
      var newLinesCount = 0;
      var body = opts.body;

      if (body instanceof FormData) {
        newVariantId = body.get('id');
      } else if (typeof body === 'string') {
        try {
          var parsed = JSON.parse(body);
          if (parsed.id) {
            newVariantId = String(parsed.id);
          } else if (parsed.items && Array.isArray(parsed.items)) {
            parsed.items.forEach(function (item) {
              if (!existingVariantIds[String(item.id)]) {
                newLinesCount++;
              }
            });
          }
        } catch (e) {
          try {
            var params = new URLSearchParams(body);
            newVariantId = params.get('id');
          } catch (e2) { /* ignorar */ }
        }
      }

      if (newVariantId && !existingVariantIds[String(newVariantId)]) {
        newLinesCount = 1;
      }

      if (currentLines + newLinesCount > MAX_LINES) {
        showPopup();
        restoreSubmitButtons();

        return Promise.resolve(new Response(
          JSON.stringify({
            status: 422,
            message: POPUP_MESSAGE,
            description: POPUP_MESSAGE
          }),
          {
            status: 422,
            statusText: 'Unprocessable Entity',
            headers: { 'Content-Type': 'application/json' }
          }
        ));
      }

      return originalFetch.apply(window, args);
    })
    .catch(function (err) {
      console.warn('[Cart Limit] Error consultando carrito, permitiendo add:', err);
      return originalFetch.apply(window, args);
    });
  };

  // =========================================================================
  // Interceptar XMLHttpRequest como respaldo (algunas apps usan XHR)
  // =========================================================================
  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartLimitMethod = method;
    this._cartLimitUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    var method = (xhr._cartLimitMethod || 'GET').toUpperCase();
    var url = xhr._cartLimitUrl || '';

    var isCartAdd = method === 'POST' && /\/cart\/add/i.test(url);

    if (!isCartAdd) {
      return originalXHRSend.apply(this, arguments);
    }

    var checkReq = new XMLHttpRequest();
    checkReq.open('GET', '/cart.js', true);
    checkReq.setRequestHeader('Accept', 'application/json');
    checkReq.onload = function () {
      try {
        var cartData = JSON.parse(checkReq.responseText);
        var currentLines = cartData.items ? cartData.items.length : 0;

        if (currentLines >= MAX_LINES) {
          showPopup();
          restoreSubmitButtons();

          Object.defineProperty(xhr, 'status', { value: 422, writable: false });
          Object.defineProperty(xhr, 'responseText', {
            value: JSON.stringify({ status: 422, message: POPUP_MESSAGE }),
            writable: false
          });
          if (xhr.onload) xhr.onload();
          return;
        }

        originalXHRSend.call(xhr, body);
      } catch (e) {
        originalXHRSend.call(xhr, body);
      }
    };
    checkReq.onerror = function () {
      originalXHRSend.call(xhr, body);
    };
    checkReq.send();
  };

  console.log('[Cart Limit] Activo \u2014 m\u00e1ximo ' + MAX_LINES + ' productos distintos');
})();